import React from "react";
import { useState, useEffect } from "react";
import { TextInput, Dropdown, AccordionV2, AccordionItemV2, Icon, Font, Modal, Checkbox, Button } from "pepsico-ds";
import { useUserProfile } from "../../../common/user_profile_context";
import { useTranslation } from "react-i18next";

const ContractorInformationEdit = ({ onPersonalInfoValidate, userDetailResp, isEditable, setIsEditable }) => {
    // const [isEditable, setIsEditable] = useState(false);
    const { t } = useTranslation();
    const { userProfile, loading } = useUserProfile();
    const onClickCancel = () => {
        setIsEditable(false);
        setFormChanged(false);
    };

    useEffect(() => {
        if (loading || !userProfile) return;
    }, [loading, userProfile]);

    const labels = {
        company: t("updateProfile.company"),
        location: t("updateProfile.location"),
        department: t("updateProfile.department"),
        organization: t("updateProfile.organization"),
        category: t("updateProfile.category"),
        project: t("updateProfile.project"),
        expirationDate: t("updateProfile.expirationDate")
    };

    const [formValues, setFormValues] = useState({
        company: userDetailResp?.company,
        location: userDetailResp?.location,
        department: userDetailResp?.department,
        organization: userDetailResp?.organization,
        category: userDetailResp?.category,
        project: userDetailResp?.project,
        expirationDate: userDetailResp?.expirationDate
    });

    const [formChanged, setFormChanged] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [copyButtonText, setCopyButtonText] = useState("Copy number");
    const [showChangeConfirmModal, setShowChangeConfirmModal] = useState(false);
    const [isChecked, setCheckbox] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (loading || !userProfile) return;
        // setFormValues((prev) => ({
        //     ...prev,
        //     gpId: userProfile.gpId || "",
        //     email: userProfile.email || "",
        //     firstName: userProfile.firstName || "",
        //     lastName: userProfile.lastName || "",
        //     pronouns: userProfile.pronouns || "",
        //     displayedFirstName: userProfile.displayedFirstName || "",
        //     displayedLastName: userProfile.displayedLastName || "",
        //     preferredName: userProfile.preferredName || "",
        //     associateType: userProfile.associateType || "",
        //     registered: userProfile.registered ? "True" : "False" || "",
        // }));
    }, [loading, userProfile]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
        setFormChanged(true);
    };

    const handleDropdownChange = (name, selectedValue) => {
        setFormValues((prev) => ({
            ...prev,
            [name]: selectedValue,
        }));
        setFormChanged(true);
    };

    const isFieldDisabled = (fieldName) => {
        let disabledFields = [];
        // if (userProfile?.associateType?.toLowerCase()?.includes("contractor")) {
            disabledFields = ["company", "category", "project", "expirationDate", "location", "organization", "division", "subdivision", "officePhone", "extension", "department", "location", "registered"];
        // }
        return disabledFields.includes(fieldName);
    };

    const renderContractorInfo = () => {
        return (
            <div className="row">
                <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                    {isEditable ? (
                        <TextInput label={labels.company} type="text" value={formValues.company} disabled={isFieldDisabled("company")} />
                    ) : (
                        <InfoRow label={labels.company} value={formValues.company  || t("auditRequest.not_applicable")} />
                    )}
                </div>

                <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                    {isEditable ? (
                        <TextInput
                            label={labels.location}
                            name="location"
                            type="text"
                            disabled={isFieldDisabled("location")}
                            value={formValues.location}
                            onChange={handleInputChange}
                        />
                    ) : (
                        <InfoRow label={labels.location} value={formValues.location  || t("auditRequest.not_applicable")} />
                    )}
                </div>

                <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                    {isEditable ? (
                        <TextInput label={labels.department} type="text" value={formValues.department} disabled={isFieldDisabled("department")} />
                    ) : (
                        <InfoRow label={labels.department} value={formValues.department  || t("auditRequest.not_applicable")} />
                    )}
                </div>
                <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                    {isEditable ? (
                        <TextInput
                            label={labels.organization}
                            name="organization"
                            type="text"
                            disabled={isFieldDisabled("organization")}
                            value={formValues.organization}
                            onChange={handleInputChange}
                        />
                    ) : (
                        <InfoRow label={labels.organization} value={formValues.organization  || t("auditRequest.not_applicable")} />
                    )}
                </div>

                <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                    {isEditable ? (
                        <TextInput label={labels.category} type="text" value={formValues.category} disabled={isFieldDisabled("category")} />
                    ) : (
                        <InfoRow label={labels.category} value={formValues.category  || t("auditRequest.not_applicable")} />
                    )}
                </div>
                <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                    {isEditable ? (
                        <TextInput label={labels.project} type="text" value={formValues.project} disabled={isFieldDisabled("project")} />
                    ) : (
                        <InfoRow label={labels.project} value={formValues.project  || t("auditRequest.not_applicable")} />
                    )}
                </div>

                <div className={isMobile ? "col-6 col-md-4 col-lg-3 mb-3" : "col-12 col-md-4 col-lg-3 mb-3"}>
                    {isEditable ? (
                        <TextInput label={labels.expirationDate} type="text" value={formValues.expirationDate} disabled={isFieldDisabled("expirationDate")} />
                    ) : (
                        <InfoRow label={labels.expirationDate} value={formValues.expirationDate  || t("auditRequest.not_applicable")} />
                    )}
                </div>
            </div>
        )
    }


    const closeModal = () => {
        setShowModal(false);
        setCheckbox(false);
    }
    const onClickCheckbox = (isChecked) => {
        setCheckbox(isChecked);
    }

    const onClickAccept = () => {
        setShowModal(false);
        setShowChangeConfirmModal(true);
    }
    const onCloseChangeModal = () => {
        setShowChangeConfirmModal(false);
        onClickCancel();
    }

    const onClickCopynumber = () => {
        setCopyButtonText("Copied");

    }

    const renderChangeRequestConfirm = () => {
        return (
            <Modal
                showModal={showChangeConfirmModal}
                className=""
                onCloseModal={onCloseChangeModal}
                closeOnOutsideClick = {false}
                notificationsProps={{
                    primaryActionLabel: (
                        <>
                            <Icon
                                alt="alt value"
                                icon={copyButtonText == "Copied" ? "check" : "content_copy"}
                                size="medium"
                                style={{ marginRight: '6px', display: 'unset' }}
                            />

                            {copyButtonText}
                        </>
                    ),
                    primaryActionOnClick: onClickCopynumber,
                    text: '12345678',
                    title: 'Ticket number',
                    type: 'info'
                }}
                showAuxiliaryButton={false}
                showLink={false}
                showPrimaryButton={false}
                showSecondaryButton={false}
                showSlot
                showTertiaryButton={false}
                showCloseButton={true}
                style={{}}
                text="The ticket number assign to this request is: 1382555007. Please save this number to reference the request in the future. "
                title="Change request confirmation"
                type="fluid"
                viewPort={isMobile ? "mobile" : "desktop"}
            >
            </Modal>
        )
    }

    const renderConfirmModal = () => {
        return (
            <Modal
                showModal={showModal}
                className=""
                onCloseModal={closeModal}
                closeOnOutsideClick
                // footerProps={{
                //     size: 'medium',
                //     type: 'primary'
                // }}
                notificationsProps={{
                    text: 'While meant to be inclusivity resource, Display Name requests should be kept to a minimum and used on an as needed basis only.',
                    title: '',
                    type: 'warning',
                }}
                showAuxiliaryButton={false}
                showLink={false}
                showPrimaryButton={false}
                showSecondaryButton={false}
                showSlot
                showTertiaryButton={false}
                showCloseButton={true}
                style={{}}
                text="Making this change to Display Name will create a system-wide Display Name change in several down-stream applications (for example email & Zoom). Please ensure correct spelling, and note that Display Names should be used in a professional and responsible manner, including in compliance with Company policy and all applicable laws."
                title="Change delegated manager?"
                type="fluid"
                viewPort={isMobile ? "mobile" : "desktop"}
            >
                <Checkbox
                    checked={isChecked}
                    className=""
                    size="large"
                    style={{}}
                    onUpdate={(value) => onClickCheckbox(value)}
                    text="I have read and understand the information listed above"
                />
                <div className="confirm-modal-btn">
                    <Button
                        className=""
                        size="medium"
                        style={{}}
                        text="Cancel"
                        variant="tertiary"
                        onClick={closeModal}
                    />
                    <Button
                        className=""
                        size="medium"
                        style={{}}
                        text="Accept & continue"
                        variant="primary"
                        disabled={!isChecked}
                        onClick={onClickAccept}
                    />

                </div>
            </Modal>
        )
    }

    const renderMobile = () => (
        <div className="main-container">
            <div className="mobile-profile-wrapper">
                <div className="mobile-profile-container">
                    <AccordionV2
                        className=""
                        presentation="border"
                        separator
                        style={{}}
                    >
                        <AccordionItemV2
                            label={t("updateProfile.contractorInfo")}
                            icon="domain"
                        >
                            <Font textColorClass="$color-text-secondary">
                                {renderContractorInfo()}
                            </Font>
                        </AccordionItemV2>
                    </AccordionV2>

                </div>
                {/* <div className="save-container">
                    <div className="edit-status">
                        <span className="edit-mode-text">Edit mode</span>
                        <span style={{ fontSize: 14, color: "#616161" }}>
                            {formChanged ? "1 change made" : "0 changes made"}
                        </span>
                    </div>

                    <div className="edit-status">
                        <button className="mobile-save-button" style={{ marginBottom: 4 }} onClick={() => setShowModal(true)}>
                            Save changes
                        </button>
                        <button className="mobile-cancel-button" onClick={onClickCancel}>
                            Cancel
                        </button>
                    </div>
                </div> */}
            </div>
            {showModal && renderConfirmModal()}
            {showChangeConfirmModal && renderChangeRequestConfirm()}
        </div>
    );

    const renderDesktop = () => (
        <div className="main-container">
            <div className="associate-infor-container">

                <section className="section Contractor-info">
                    <Icon
                        alt="alt value"
                        icon="domain"
                        size="large"
                        style={{ marginBottom: '8px', color: "#3A3A3A" }}
                    />
                    <h3 style={{ color: "#0E647F" }}>{t("updateProfile.contractorInfo")}</h3>
                    {renderContractorInfo()}
                </section>

                {/* {isEditable ?
                    <div>
                        <hr className="profile-divider" />
                        <div className="d-flex justify-content-between mb-4">
                            <div className="edit-status">
                                <span className="edit-mode-text">Edit mode</span>
                                <span style={{ fontSize: 14, color: "#616161" }}>
                                    {formChanged ? "1 change made" : "0 changes made"}
                                </span>
                            </div>

                            <div className="edit-actions">
                                <button className="cancel-button" onClick={onClickCancel}>
                                    <Icon
                                        alt="alt value"
                                        icon="close"
                                        size="large"
                                        style={{ marginRight: '8px' }}
                                    />
                                    Cancel
                                </button>
                                <button className="save-button" disabled={!formChanged} onClick={() => setShowModal(true)}>
                                    Save changes
                                </button>
                            </div>
                        </div>
                    </div>
                    : <div>
                        <hr className="profile-divider" />
                        <div className="d-flex justify-content-end mb-4">
                            <button className="edit-button" onClick={setIsEditable.bind(this, true)}>
                                <Icon
                                    alt="alt value"
                                    icon="edit"
                                    size="large"
                                    style={{ marginRight: '8px' }}
                                />
                                Edit mode
                            </button>
                        </div>
                    </div>
                } */}
            </div>

            {showModal && renderConfirmModal()}
            {showChangeConfirmModal && renderChangeRequestConfirm()}


        </div>
    );

    return isMobile ? renderMobile() : renderDesktop();
}

const InfoRow = ({ label, value }) => (
    <Font textColorClass="$color-text-secondary">
        <div className="profile-info">
            <span className="profile-label">{label}</span>
            <span className="profile-value">{value}</span>
        </div>
    </Font>
);

export default ContractorInformationEdit;